import template from './jobs-filter.html';
import JobsFilterController from './jobs-filter.controller';
import './jobs-filter.styl';

let jobsFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: JobsFilterController,
  controllerAs: 'vm'
};

export default jobsFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/jobs-filter/jobs-filter.component.js
 **/